<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">假期名称：</span>
        </div>
        <el-input v-model="formData.holidayName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">假期开始时间：</span>
        </div>
        <el-date-picker v-model="formData.holidayStartTime" type="date" format='yyyy-MM-dd' value-format="yyyy-MM-dd" size="small" style="width: 280px" placeholder="假期开始时间"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">假期结束时间：</span>
        </div>
        <el-date-picker v-model="formData.holidayEndTime" type="date" format='yyyy-MM-dd' value-format="yyyy-MM-dd" size="small" style="width: 280px" placeholder="假期结束时间"></el-date-picker>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/AttendancePoint'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'attendance-vacation-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '假期管理'
        }],
        mainTitle: '修改假期',
        subheading: '',

        deptCodeList: [],
        formData: {
          code: '',
          deptName: '',
        },
      }
    },
    created () {
      this.getAttendanceHolidayByCode()
    },
    methods: {
      toManagementPage () {
        this.$router.push({
          name: 'attendance-vacation-manage'
        })
      },

      // 查询
      getAttendanceHolidayByCode () {
        this.$axios.get(`${api.getAttendanceHolidayByCode}/${this.$route.params.id}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.formData = res.data.data
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 修改
      confirm () {
        if (!this.formData.holidayName) {
          nError('请输入假期名称')
          return false
        }
        if (!this.formData.holidayStartTime) {
          nError('请选择假期开始时间')
          return false
        }
        if (!this.formData.holidayEndTime) {
          nError('请选择假期结束时间')
          return false
        }
        this.$axios.post(api.updateAttendanceHoliday, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('修改失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceVacation/AttendanceVacationModify.vue